import { apiClient, getUserId } from "./authService";

interface PromoData {
  [key: string]: any;
}

export const getAllCommunity = async (businessId?: string): Promise<any> => {
  try {
    const userId = getUserId();
    if (!userId) throw new Error("User ID not found. Please log in again.");
    
    let url = `/clients/groups/${businessId}`;
   
    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createCommunity = async (branchData: PromoData): Promise<any> => {
  try {
    const response = await apiClient.post("/clients/community", branchData);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const AssignClients= async (
  id: string,
  branchData: PromoData
): Promise<any> => {
  try {
    const response = await apiClient.post(`/clients/group/${id}`, branchData);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const GetAssignedClients = async (
  id: string
): Promise<any> => {
  try {
    const response = await apiClient.get(`/clients/group/${id}/members`);
    return response.data;
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const updateCommunity = async (
  id: string,
  branchData: PromoData
): Promise<any> => {
  try {
    const response = await apiClient.put(`/clients/group/${id}`, branchData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteCommunity = async (id: string): Promise<any> => {
  try {
    const response = await apiClient.delete(`/clients/group/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const deleteMember = async (id: string, memberId: string): Promise<any> => {
  try {
    const response = await apiClient.delete(`/clients/group/${id}/members/${memberId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
